export default {
      id: "telegram-usage",
      viewBox: "0 0 25 24",
      url: __webpack_public_path__ + "img/icons.ec9c9113.svg#telegram",
      toString: function () {
        return this.url;
      }
    }